import { Type } from '@angular/core';

export abstract class ParserBase<TModel, TPresenter> {
  constructor(
    public modelType: Type<TModel>,
    public presenterType: Type<TPresenter>,
    public version: number,
  ) {}

  abstract getPresenterModel(model: Partial<TModel>): TPresenter;
  abstract getDataModel(presenter: TPresenter): TModel;
}
